import { Filters } from "toptaal-shared"
import { User } from "../types/user"

export const userQueryKeys = {
  all: ["users"] as const,
  current: () => [...userQueryKeys.all, "current"] as const,
  detail: (id: User["userId"]) => [...userQueryKeys.all, id] as const,
  schedule: (id: User["userId"]) =>
    [...userQueryKeys.detail(id), "schedule"] as const,
  scheduleWithDates: (id: User["userId"], startDate: string, endDate: string) =>
    [...userQueryKeys.schedule(id), startDate, endDate] as const,
  filters: (filters: Filters) =>
    [...userQueryKeys.all, "filters", filters] as const,
}

export const toptaalUserQueryKeys = {
  all: ["toptaal_users"] as const,
  detail: (id: User["userId"]) => [...toptaalUserQueryKeys.all, id] as const,
  groups: (id: User["userId"]) =>
    [...toptaalUserQueryKeys.detail(id), "groups"] as const,
  teachers: (filters: Filters) =>
    [...toptaalUserQueryKeys.all, "teachers", filters] as const,
}

export const intakerQueryKeys = {
  all: ["intakers"] as const,
  filters: ({
    date,
    startTime,
    endTime,
    locationId,
    projectTypes,
    intakeId,
  }: {
    date?: string
    startTime?: string
    endTime?: string
    locationId?: number
    projectTypes?: string[]
    intakeId?: number
  }) =>
    [
      ...intakerQueryKeys.all,
      "filters",
      date,
      startTime,
      endTime,
      locationId,
      projectTypes,
      intakeId,
    ] as const,
}
